import React from 'react'

import { MenuSearchContent } from '@library/menu-page'
import type { MenuSearchContentProps } from '@library/menu-page'

import { MenuExperienceSearchLandingSkeleton } from '../LoadingSkeleton/MenuExperienceSearchLandingSkeleton'
import { RelevantRecipesSkeleton } from '../LoadingSkeleton/RelevantRecipesSkeleton'
import { SearchError } from '../SearchError/SearchError'
import { SearchRecipe } from './SearchRecipeData'
import type { MenuExperienceSearchViewState } from './menuExperienceSearchViewState'

type MenuExperienceSearchResultsProps = Omit<MenuSearchContentProps, 'response'> & {
  retry: () => void
  viewState: MenuExperienceSearchViewState
}

export const MenuExperienceSearchResults = ({
  canAddRecipes,
  getIsInBasket,
  getQuantity,
  onAddRecipe,
  onBlockedAddAttempt,
  onCategoryClick,
  onRecipeClick,
  onRemoveRecipe,
  reachedLimit,
  renderFlexPortionControl,
  retry,
  viewState,
}: MenuExperienceSearchResultsProps) => {
  if (viewState.status === 'error') return <SearchError onRetry={retry} />

  if (viewState.status === 'ready' || viewState.status === 'replacing') {
    return (
      <MenuSearchContent
        canAddRecipes={canAddRecipes}
        getIsInBasket={getIsInBasket}
        getQuantity={getQuantity}
        onAddRecipe={onAddRecipe}
        onBlockedAddAttempt={onBlockedAddAttempt}
        onCategoryClick={onCategoryClick}
        onRecipeClick={onRecipeClick}
        onRemoveRecipe={onRemoveRecipe}
        reachedLimit={reachedLimit}
        renderFlexPortionControl={renderFlexPortionControl}
        response={viewState.response}
        RecipeComponent={SearchRecipe}
      />
    )
  }

  if (viewState.status !== 'loading') return null

  return viewState.query ? <RelevantRecipesSkeleton /> : <MenuExperienceSearchLandingSkeleton />
}
